import { Flex, Space, Text, Textarea } from '@billy/design-system'
import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import { INVOICE_MESSAGE_CHARACTER_LIMIT } from '@features/invoices/constants/invoiceMessageCharacterLimit'

import { useDebouncedCallback } from '../../../../../../../../../../hooks/useDebouncedCallback'
import { useInvoiceEditorForm } from '../../../../../../contexts/invoiceEditorFormContext'
import { useIsInvoiceEditorElementRestricted } from '../../../../../../hooks/useIsInvoiceEditorElementRestricted'

export const InvoiceMessage = (): ReactElement => {
  const { t } = useTranslation()
  const { invoiceEditorForm, trackInvoiceEditor } = useInvoiceEditorForm()
  const isDisabled = useIsInvoiceEditorElementRestricted('message', 'disabled')
  const { FormItem, watch } = invoiceEditorForm

  const message = watch('message')

  const handleDebouncedTextareaChange = useDebouncedCallback((value: string) =>
    trackInvoiceEditor('Form - Invoice Message typed', {
      messageLength: value.length,
    }),
  )

  return (
    <FormItem
      name="message"
      itemColumnStart={1}
      itemColumnEnd={3}
      label={
        <Flex justifyContent="space-between">
          <Text colorVariant="secondary">{t('external_invoices.editor.form.field.invoice_message.label')}</Text>
          <Space size="s24" horizontal />
          <Text colorVariant="secondary">{`${message.length}/${INVOICE_MESSAGE_CHARACTER_LIMIT}`}</Text>
        </Flex>
      }
      render={({ field: { value, onChange, ...props } }) => {
        return (
          <Textarea
            {...props}
            disabled={isDisabled}
            expandOnType
            maxHeight={160}
            maxLength={INVOICE_MESSAGE_CHARACTER_LIMIT}
            onChange={(event) => {
              onChange(event)
              handleDebouncedTextareaChange(event.target.value)
            }}
            placeholder={t('external_invoices.editor.form.field.invoice_message.placeholder')}
            resizable={false}
            rows={1}
            value={value}
            size="sm"
          />
        )
      }}
    />
  )
}
